"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var NavigationMenuButton_styled_exports = {};
__export(NavigationMenuButton_styled_exports, {
  StyledLabel: () => StyledLabel,
  StyledMenuButton: () => StyledMenuButton,
  StyledMenuButtonContainer: () => StyledMenuButtonContainer,
  StyledMenuButtonContent: () => StyledMenuButtonContent,
  StyledMenuButtonIconContainer: () => StyledMenuButtonIconContainer,
  StyledMenuButtonLayout: () => StyledMenuButtonLayout,
  StyledOptionText: () => StyledOptionText,
  StyledOptionsList: () => StyledOptionsList,
  disabledStyles: () => disabledStyles
});
module.exports = __toCommonJS(NavigationMenuButton_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var disabledStyles = function disabledStyles2(theme, darkMode) {
  var border = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  return (0, import_styled_components.css)(["background:", ";cursor:not-allowed;", ";color:", ";&:hover{", ";background-color:", ";color:", ";}"], darkMode ? theme.colors.n[80] : theme.colors.n[10], border === false && "border: none", darkMode ? theme.colors.n[30] : theme.colors.n[60], border === false && "border: none", theme.colors.n[10], darkMode ? theme.colors.n[30] : theme.colors.n[60]);
};
var errorStyles = function errorStyles2(theme, error) {
  if (error) {
    return (0, import_styled_components.css)(["box-shadow:0 0 0 2px ", ";"], theme.colors.status.error[100]);
  }
  return (0, import_styled_components.css)(["box-shadow:0 0 0 1px ", ";"], theme.colors.beige[180]);
};
var darkModeStyles = function darkModeStyles2(theme, darkMode, error, disabled) {
  if (darkMode && error) {
    return (0, import_styled_components.css)(["background-color:", ";color:", ";"], theme.colors.status.error[20], theme.colors.n[100]);
  }
  if (darkMode && disabled) {
    return (0, import_styled_components.css)(["background-color:", ";color:", ";&:hover{background-color:", ";}"], theme.colors.n[85], theme.colors.n[30], theme.colors.n[80]);
  }
  return (0, import_styled_components.css)(["background-color:", ";color:", ";&:hover{box-shadow:0 0 0 2px ", ";}"], theme.colors.n[100], theme.colors.white, theme.colors.beige[140]);
};
var StyledMenuButtonContainer = import_styled_components.default.div.withConfig({
  displayName: "NavigationMenuButtonstyled__StyledMenuButtonContainer",
  componentId: "sc-1yv8vfp-0"
})(function(_ref) {
  var theme = _ref.theme;
  return (0, import_styled_components.css)(["font-family:", ";display:flex;align-items:center;flex-direction:column;max-width:400px;min-width:130px;position:relative;"], theme.typography.fonts.primary);
});
var StyledLabel = import_styled_components.default.label.withConfig({
  displayName: "NavigationMenuButtonstyled__StyledLabel",
  componentId: "sc-1yv8vfp-1"
})(function(_ref2) {
  var theme = _ref2.theme, darkMode = _ref2.darkMode, disabled = _ref2.disabled;
  return (0, import_styled_components.css)(["text-align:left;font-size:", ";line-height:", ";color:", ";width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;", " &:hover{", "}"], theme.typography.sizes.small, theme.measurements.extraExtraLarge, darkMode ? theme.colors.white : theme.colors.n[100], disabled && disabledStyles(theme, darkMode), darkMode && disabled && "background: ".concat(theme.colors.n[80]));
});
var StyledMenuButton = import_styled_components.default.button.withConfig({
  displayName: "NavigationMenuButtonstyled__StyledMenuButton",
  componentId: "sc-1yv8vfp-2"
})(function(_ref3) {
  var theme = _ref3.theme, disabled = _ref3.disabled, darkMode = _ref3.darkMode, error = _ref3.error;
  return (0, import_styled_components.css)(["background-color:", ";box-sizing:border-box;cursor:pointer;height:56px;width:100%;padding:6px 14px 6px 12px;border-style:none;", ";.select__label{display:block;}.navigation__menubutton-layout-selected{display:block;text-align:left;font-size:", ";text-overflow:ellipsis;white-space:nowrap;overflow:hidden;}.navigation__menubutton-layout-placeholder{display:block;text-align:left;font-size:", ";}&:hover{box-shadow:0 0 0 2px ", ";&:disabled{box-shadow:none;}}&:disabled{box-shadow:none;}", " ", " ", ";"], theme.colors.white, (0, import_mixins.withBorderRadius)(theme.measurements.small), theme.typography.sizes.medium, theme.typography.sizes.medium, theme.colors.beige[180], disabled && disabledStyles(theme, darkMode), errorStyles(theme, error), darkMode && darkModeStyles(theme, darkMode, error, disabled));
});
var StyledMenuButtonLayout = import_styled_components.default.div.withConfig({
  displayName: "NavigationMenuButtonstyled__StyledMenuButtonLayout",
  componentId: "sc-1yv8vfp-3"
})(function() {
  return (0, import_styled_components.css)(["display:flex;align-items:center;width:100%;height:100%;"]);
});
var StyledMenuButtonIconContainer = import_styled_components.default.div.withConfig({
  displayName: "NavigationMenuButtonstyled__StyledMenuButtonIconContainer",
  componentId: "sc-1yv8vfp-4"
})(function() {
  return (0, import_styled_components.css)(["display:flex;justify-content:center;align-items:center;"]);
});
var StyledMenuButtonContent = import_styled_components.default.div.withConfig({
  displayName: "NavigationMenuButtonstyled__StyledMenuButtonContent",
  componentId: "sc-1yv8vfp-5"
})(["flex-grow:1;margin-left:10px;overflow:hidden;"]);
var StyledOptionText = import_styled_components.default.span.withConfig({
  displayName: "NavigationMenuButtonstyled__StyledOptionText",
  componentId: "sc-1yv8vfp-6"
})(function(_ref4) {
  var theme = _ref4.theme, darkMode = _ref4.darkMode;
  return (0, import_styled_components.css)(["-webkit-text-fill-color:", ";"], darkMode ? theme.colors.white : theme.colors.black);
});
var StyledOptionsList = import_styled_components.default.ul.withConfig({
  displayName: "NavigationMenuButtonstyled__StyledOptionsList",
  componentId: "sc-1yv8vfp-7"
})(function(_ref5) {
  var theme = _ref5.theme, isOpen = _ref5.isOpen;
  return (0, import_styled_components.css)(["display:", ";border:1px solid ", ";background-color:", ";box-shadow:0px 12px 16px rgba(0,0,0,0.1);max-height:300px;overflow-y:auto;padding:0;width:100%;z-index:1;left:0;margin:0;.select__option{&:first-child{border-top:0px;}}", ";", ""], isOpen ? "block" : "none", theme.colors.beige[180], theme.colors.white, (0, import_mixins.withBorderRadius)(theme.measurements.small), (0, import_mixins.withStyledScrollBar)());
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledLabel,
  StyledMenuButton,
  StyledMenuButtonContainer,
  StyledMenuButtonContent,
  StyledMenuButtonIconContainer,
  StyledMenuButtonLayout,
  StyledOptionText,
  StyledOptionsList,
  disabledStyles
});
//# sourceMappingURL=NavigationMenuButton.styled.js.map